
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/admin",
      function () {
        return require("private-next-pages/login/admin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/admin"])
      });
    }
  